module.exports = __webpack_public_path__ + "img/swiper1-2.0468b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/findUs/swiper1-2.png
// module id = 351
// module chunks = 0